import { render, staticRenderFns } from "./CharacterList.vue?vue&type=template&id=aff3655c"
import script from "./CharacterList.vue?vue&type=script&lang=js"
export * from "./CharacterList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports